import { indexItems } from '@/mocks/home';

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 bg-secondary-100 text-secondary-700 text-xs font-medium rounded-full mb-4">
            分类导航
          </span>
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-900">
            漫画分类
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-lg mx-auto">
            按题材快速筛选，精准找到你喜欢的漫画类型
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {indexItems.map((item) => (
            <div
              key={item.id}
              className="group bg-background-50 border border-background-200 rounded-xl p-6 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-11 h-11 flex items-center justify-center bg-primary-50 rounded-xl group-hover:bg-primary-100 transition-colors">
                  <i className={`${item.icon} text-primary-500 text-xl`}></i>
                </div>
                <div>
                  <h3 className="text-base font-semibold text-foreground-900">{item.title}</h3>
                  <p className="text-xs text-foreground-400">{item.desc}</p>
                </div>
              </div>
              <div className="flex flex-wrap gap-1.5">
                {item.tags.map((tag) => (
                  <span
                    key={tag}
                    className="px-2.5 py-1 bg-background-100 text-foreground-600 text-xs rounded-md hover:bg-primary-50 hover:text-primary-600 transition-colors"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}